import React, { useEffect, useState } from "react";
import { signIn } from "@api";
import AccessDenied from "./accessDenied/AccessDenied";

const Authenticate = ({ children }: { children: React.ReactElement }) => {
  const [, token] = window.location.search.split("?token=");
  const [t, setT] = useState(false);

  const signInHandler = async () => {
    try {
      const response = await signIn(token);
      if (response.status === 200) {
        setT(true);
      }
    } catch (e) {
      console.error("signInHandler", { e });
      setT(false);
    }
  };

  useEffect(() => {
    signInHandler();
  }, [token]);

  if (!token) return <AccessDenied />;

  return <>{t ? children : <AccessDenied />}</>;
};

export default Authenticate;
